/**
 * 隐秘处方模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 获取隐秘处方列表
export const comboRecipeList = (params) => {
  return req.get('/hosp/combo/list', params);
}

// 新增隐秘处方
export const comboRecipeAdd = (params) => {
  return req.post('/hosp/combo', params);
}

// 获取隐秘处方详细信息
export const comboRecipeDetails = (comboId) => {
  return req.get(`/hosp/combo/${comboId}`);
}

// 修改隐秘处方
export const comboRecipeEdit = (params) => {
  return req.put('/hosp/combo', params);
}

// 删除隐秘处方
export const comboRecipeDelete = (comboId) => {
  return req.delete(`/hosp/combo/${comboId}`);
}


// 获取医联产品的全部医生
export const getComboDocAll = () => {
  return req.get(`/hosp/combo/doctor/all`);
}
// 查询医联产品列表
export const getComboList = (params) => {
  return req.get(`/hosp/combo/list`, params);
}

// 查询医联产品
export const getCombo = (comboId) => {
  return req.get(`/hosp/combo/${comboId}`, );
}

// 医联产品
export const removeCombo = (params) => {
  return req.get(`/hosp/combo/remove`, params );
}
// 添加医联产品
export const addCombo = (params) => {
  return req.post(`/hosp/combo/add`, params );
}
// 修改医联产品和明细
export const editComboAndItem = (params) => {
  return req.post(`/hosp/combo/editComboAndItem`, params );
}

// 移动医联产品位置
export const moveCombo = (params) => {
  return req.get(`/hosp/combo/moveCombo`, params );
}

